import { useState, useCallback, useMemo } from "react";
import { ITransferListProps } from "./TransferList.types";
import { createHierarchies, createCandidatesHierarchies, createSelectedHierarchies, createSelection } from "./TransferList.utils";

export function useTransferList(props: ITransferListProps) {
  const { selection, items } = props;
  const [searchValue, onSearchHandler] = useState("");
  const hierarchies = useMemo(() => createHierarchies(items, searchValue), [items, searchValue]);

  const [selectedIds, setSelectedIds] = useState<(number | string)[]>([]);

  const onToggleItemHandler = useCallback(
    (itemId: number | string) => {
      setSelectedIds((state) => createSelection(state, itemId, hierarchies));
    },
    [setSelectedIds, hierarchies]
  );

  const { candidateHierarchies, selectedHierarchies } = useMemo(() => {
    const candidateHierarchies = createCandidatesHierarchies(selection, hierarchies);
    const selectedHierarchies = createSelectedHierarchies(selection, hierarchies);

    return { candidateHierarchies, selectedHierarchies };
  }, [hierarchies, selection]);

  return {
    hierarchies,
    searchValue, 
    candidateHierarchies,
    selectedHierarchies,
    selectedIds,
    onToggleItemHandler,
    onSearchHandler,
  };
}
